import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { NotificationTypesEnum } from '../../../../interfaces';
import { SinceDatePipe } from '../../../../pipes/since-date.pipe';
import { AuthService } from '../../../../services/auth.service';
import { ProjectService } from '../../../../services/project.service';
import { SocketService } from '../../../../services/socket.service';
import { NotificationService } from '../../../../services/notification.service';
import { SignalRService } from '../../../../services/signal-r.service';

@Component({
  selector: 'app-chat',
  standalone: true,
  imports: [InputTextModule, ButtonModule, CommonModule, FormsModule, SinceDatePipe],
  templateUrl: './chat.component.html',
  styleUrl: './chat.component.scss'
})
export class ChatComponent implements OnInit {
  @Input() strategyId!: number;
  @Input() projectId!: number;
  user: any;

  constructor(
    private projectService: ProjectService,
    private authService: AuthService,
    private socket: SocketService,
    private notificationService: NotificationService,
    private signalRService: SignalRService,
    private cdr: ChangeDetectorRef
  ) {
  }

  messageTimeLine: any[] = [];

  ngOnInit(): void {
    this.authService.authBufferSub$.subscribe((user) => {
      this.user = user;
    })

    this.projectService.listMessages(this.strategyId, this.projectId).subscribe((res: any) => {
      // تحويل created_at من string (ISO) إلى timestamp لضمان التوافق
      this.messageTimeLine = res.data.messages.map((msg: any) => {
        if (msg.created_at) {
          // إذا كان string، تحويله إلى timestamp
          if (typeof msg.created_at === 'string') {
            msg.created_at = new Date(msg.created_at).getTime();
          }
          // التأكد من أن created_at هو number (timestamp)
          if (typeof msg.created_at !== 'number') {
            msg.created_at = new Date(msg.created_at).getTime();
          }
        } else {
          // إذا لم يكن موجوداً، استخدام الوقت الحالي
          msg.created_at = Date.now();
        }
        return msg;
      });
      this.cdr.detectChanges(); // إجبار Angular على تحديث الـ view
      setTimeout(() => {
        this.scrollToBottom();
      }, 500);
    });

    // الانضمام إلى غرفة المشروع للاستماع للرسائل
    if (this.projectId) {
      this.signalRService.joinProject(this.projectId).subscribe({
        next: () => console.log('Joined project chat room'),
        error: (err) => console.error('Error joining project chat room:', err)
      });
    }

    // الاستماع لرسائل المشروع عبر SignalR بشكل مباشر
    this.signalRService.listenToProjectMessages().subscribe((message: any) => {
      console.log("received project message", message);
      // إضافة الرسالة فقط إذا لم تكن من المرسل الحالي (لتجنب التكرار)
      if (!message.is_sender) {
        // التأكد من أن created_at هو timestamp (number)
        let created_at = message.created_at;
        if (typeof created_at === 'string') {
          created_at = new Date(created_at).getTime();
        } else if (!created_at) {
          created_at = Date.now();
        }
        
        const messageChat = {
          type: NotificationTypesEnum.project_chat_message,
          message: message.message,
          project_id: +this.projectId,
          sender_name: message.sender_name,
          is_sender: false,
          created_at: created_at, // استخدام UTC timestamp
        };
        this.messageTimeLine.push(messageChat);
        this.cdr.detectChanges(); // إجبار Angular على تحديث الـ view
        this.scrollToBottom();
        this.notificationService.playAudio();
      }
    });
  };

  message = ''
  sendMessage() {
    if (this.message.length) {
      const messageText = this.message;
      // استخدام UTC timestamp للحصول على الوقت الصحيح
      const currentTime = Date.now(); // هذا يعطي UTC timestamp بالفعل
      const messageChat =
      {
        type: NotificationTypesEnum.project_chat_message,
        message: messageText,
        project_id: +this.projectId,
        sender_name: this.user.name,
        is_sender: true,
        created_at: currentTime,
      }
      
      // إرسال الرسالة عبر SignalR أولاً (فوراً) لسرعة الوصول
      this.messageTimeLine.push(messageChat);
      this.cdr.detectChanges(); // إجبار Angular على تحديث الـ view
      this.signalRService.sendMessageToProject(messageChat).subscribe({
        next: () => {
          this.message = '';
          this.scrollToBottom();
        },
        error: (err) => {
          console.error('Error sending message via SignalR:', err);
        }
      });
      
      // حفظ الرسالة في قاعدة البيانات بشكل غير متزامن (في الخلفية)
      this.projectService.createMessage(this.strategyId, this.projectId, messageText).subscribe({
        next: () => {
          console.log('Message saved to database');
        },
        error: (err) => {
          console.error('Error saving message to database:', err);
          // يمكن إضافة إشعار للمستخدم هنا إذا لزم الأمر
        }
      });
    } else {
      return;
    }
  };

  trackByMessageId(index: number, message: any): any {
    // استخدام index و created_at و message كـ unique identifier
    return `${index}-${message.created_at}-${message.message}`;
  }

  private scrollToBottom(): void {
    const lastMessage = document.getElementById('lastMessage');
    console.log("lastMessage", lastMessage);
    if (lastMessage) {
      setTimeout(() => {
        lastMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 500);
    }
  }

}
